import type { NavigateFunction } from "react-router";

import type { HelpSupportEntry } from "@/features/settings/helpSupportSchemas";

interface HelpSupportActionRuntime {
  assignExternal?: (target: string) => void;
  openExternal?: (
    target: string,
    targetName: string,
    features: string,
  ) => Window | null;
}

export function executeHelpSupportAction(
  entry: HelpSupportEntry,
  navigate: NavigateFunction,
  runtime: HelpSupportActionRuntime = {},
) {
  if (entry.action.kind === "internal_route") {
    navigate(entry.action.target);
    return;
  }

  if (entry.action.openMode === "same_tab") {
    const assignExternal =
      runtime.assignExternal ?? ((target: string) => window.location.assign(target));
    assignExternal(entry.action.target);
    return;
  }

  const openExternal =
    runtime.openExternal ??
    ((target: string, targetName: string, features: string) =>
      window.open(target, targetName, features));
  const openedWindow = openExternal(
    entry.action.target,
    "_blank",
    "noopener,noreferrer",
  );
  if (openedWindow) openedWindow.opener = null;
}
